import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import './About.scss';
import Page from '../../Components/Page/Page'

class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    return (
      <Page title='About Us' type='Banner'>
        <h2 className='page-title'>A Bit About Us…</h2>
        <div className='about-text about-description'>
          <p>
            A client focused accounting firm Grainger Accounting has been working together with its clients for over 25 years.
          </p>
          <p>
            We put you front and centre and pride ourselves on assisting you to develop and implement strategies to achieve your business and personal goals.
          </p>
          <p>
            Working together with you each step we provide tax and accounting advice - to individuals, businesses and self-managed superannuation funds.
          </p>
        </div>
        <h2 className='page-title'>The Future…</h2>
        <div className='about-text about-future'>
          <p>
            Grainger Accounting has purchased and moved into a new location in Belconnen - Level 1, 8-10 Purdue Street. Please see the mud map and Google map directions to locate the new premises.
          </p>
          <p>
            The new premises will provide an environment for growth whilst ensuring your needs are met. This new location has 2 hour parking at the front of the building with parking also available at the rear.
          </p>
        </div>
      </Page>
    );
  }
}

About.contextType = GraingerAccountContext;
export default About;